import axios from 'axios';
import { store } from '../store/store';
import { selectAuthToken } from '../store/auth/selectors';

//const apiClient = axios.create({ baseURL: 'http://backend-time-att.relitec.net:5005' });
const apiClient = axios.create({ baseURL: 'https://backend-time-att.relitec.net' });

apiClient.interceptors.request.use(async (request) => {
  const token = selectAuthToken(store.getState());

  if (token) {
    request.headers['Authorization'] = `Bearer ${token}`;
  }

  return request;
});

apiClient.interceptors.response.use(
  (response) => Promise.resolve(response),
  (error) => Promise.reject(error.response.data.msg || error.response.data.message),
);

export { apiClient };
